export enum LoaderStyles {
	BIG = 'Big'
}
